<template>
	<ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
		@current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
		<template slot="filters">
			<el-form-item label="操作人员" prop="createId">
				<el-select v-model="query.createId">
					<el-option v-for="item in admins" :key="item.id" :value="item.id" :label="item.name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="操作类型" prop="operationType">
				<el-select v-model="query.operationType">
					<el-option v-for="item in types" :key="item.value" :value="item.value"
						:label="item.name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="操作模块" prop="operationModule">
				<el-select v-model="query.operationModule">
					<el-option v-for="item in modules" :key="item.value" :value="item.value"
						:label="item.name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="操作时间" prop="date">
				<el-date-picker v-model="query.date" value-format="yyyy-MM-dd" type="daterange" range-separator="~"
					start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</el-form-item>
		</template>
		<template slot="btns">
			<el-button icon="el-icon-download" type="primary" size="mini" @click="handleExport">导出</el-button>
			<el-button icon="el-icon-refresh" size="mini" @click="handleSearch">刷新</el-button>
		</template>
		<template slot="columns">
			<el-table-column type="index" align="center" />
			<el-table-column label="操作人员" align="center" prop="createName" />
			<el-table-column label="操作类型" align="center" prop="operationType" />
			<el-table-column label="操作模块" align="center" prop="operationModule" />
			<el-table-column label="操作描述" align="center" prop="operationDescription" show-overflow-tooltip />
			<el-table-column label="IP地址" align="center" prop="ip" />
			<el-table-column label="操作时间" align="center" prop="createTime">
				<template slot-scope="{ row }">
					{{ formatDate(row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column label="操作结果" align="center" prop="operationResult">
				<template slot-scope="{ row }">
					<el-tag :type="row.operationResult == 1 ? 'success' : 'danger'">
						{{ ['失败', '成功'][row.operationResult] }}
					</el-tag>
				</template>
			</el-table-column>
		</template>
	</ListPage>
</template>

<script>
import { page, moduleList, typeList, excel } from "@/api/permission/log";
import { page as list } from "@/api/permission/admin";
import listMixin from '@/mixins/list';
import { startDate, endDate } from "@/pages/config";
import utils from "@/jslibs/utils";

export default {
	data() {
		return {
			// 查询参数
			query: {
				createId: "",
				operationType: "",
				operationModule: "",
				date: []
			},
			admins: [],
			types: [],
			modules: []
		};
	},
	mixins: [listMixin],
	mounted() {
		this.getAdminList();
		this.getModuleList();
		this.getTypeList();
	},
	methods: {
		getModuleList() {
			moduleList().then(({ code, data, message }) => {
				if (code == 200) {
					this.modules = data;
				} else {
					this.$message.error(message);
				}
			});
		},
		getTypeList() {
			typeList().then(({ code, data, message }) => {
				if (code == 200) {
					this.types = data;
				} else {
					this.$message.error(message);
				}
			});
		},
		getAdminList() {
			list({ page: 1, size: 9999 }).then(({ code, data, message }) => {
				if (code == 200) {
					this.admins = data.records || [];
				} else {
					this.$message.error(message);
				}
			});
		},
		handleExport() {
			const params = {
				...this.query,
				createTimeMin: this.query.date.length ? new Date(startDate(0, this.query.date[0])).getTime() : null,
				createTimeMax: this.query.date.length ? new Date(endDate(0, this.query.date[1])).getTime() : null,
			};
			delete params.date;
			delete params.page;
			delete params.size;
			excel(params).then(res => {
				const blob = new Blob([res]);
				const fileName = `操作日志.xls`;
				utils.downloadBlobFile(blob, fileName);
			})
		},
		search() {
			this.loading = true;
			const params = {
				...this.query,
				createTimeMin: this.query.date.length ? new Date(startDate(0, this.query.date[0])).getTime() : null,
				createTimeMax: this.query.date.length ? new Date(endDate(0, this.query.date[1])).getTime() : null,
			};
			delete params.date;
			page(params).then(({ code, data, message }) => {
				if (code == 200) {
					this.tableData = data.records;
					this.total = data.total;
				} else {
					this.$message.error(message);
				}
				this.loading = false;
			});
		},
		handleAdd() {
			this.$router.push("/permission/admin/form");
		},
		handleEdit(row) {
			this.$router.push({ path: "/permission/admin/form", query: { id: row.id } });
		},
		handleDel(row) {
			this.$confirm("是否删除该管理员?", "提示", {
				type: "warning",
			})
				.then(() => {
					del(row.id).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("删除成功");
							this.search();
						} else {
							this.$message.error(message);
						}
					});
				})
				.catch(() => { });
		},
	},
};
</script>